import React, { useState, useEffect } from "react";
import SimpleBar from "simplebar-react";
import { useLocation, Link } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FaBoxArchive, FaUserGroup } from "react-icons/fa6";
import {
  faHome,
  faBuilding,
  faTimes,
  faTag,
  faUsers,
  faBox,
} from "@fortawesome/free-solid-svg-icons";
import { Nav, Button, Image, Badge, Navbar } from "@themesberg/react-bootstrap";
import Cookies from "js-cookie";
import ProfilePicture from "../assets/img/team/profile-picture-3.jpg";
import { useNavigate } from "react-router-dom"; // Import the useNavigate hook
import { color } from "framer-motion";
import Logo from "../assets/img/logo/logo.svg";

export default () => {
  const location = useLocation();
  const { pathname } = location; // Get the current path to highlight active links
  const [show, setShow] = useState(false); // State for sidebar collapse/expand
  const [role, setRole] = useState(null); // State for storing the role (super admin or admin)
  const navigate = useNavigate(); // Define the navigate function using useNavigate

  useEffect(() => {
    // Retrieve the user role from cookies
    const storedRole = Cookies.get("userRole");
    setRole(storedRole);
  }, []);

  const showClass = show ? "show" : "";
  const onCollapse = () => setShow(!show);

  const NavItem = (props) => {
    const {
      title,
      link,
      external,
      icon,
      badgeText,
      badgeBg = "secondary",
      badgeColor = "primary",
    } = props;
    const navItemClassName = link === pathname ? "active" : "";
    const linkProps = external ? { href: link } : { as: Link, to: link };

    return (
      <Nav.Item className={navItemClassName} onClick={() => setShow(false)}>
        <Nav.Link {...linkProps}>
          <span className="d-flex gap-2">
            {icon && (
              <span
                className="sidebar-icon"
                style={{
                  padding: 2,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  margin: 0,
                  backgroundColor: navItemClassName ? "#9EDB6B" : "",
                  color: navItemClassName ? "white" : "",
                  borderRadius: 100,
                }}
              >
                <FontAwesomeIcon icon={icon} width={10} height={10} />{" "}
              </span>
            )}
            <span className="sidebar-text">{title}</span>
          </span>
          {badgeText && (
            <Badge
              pill
              bg={badgeBg}
              text={badgeColor}
              className="badge-md ms-2"
            >
              {badgeText}
            </Badge>
          )}
        </Nav.Link>
      </Nav.Item>
    );
  };

  return (
    <>
      <Navbar
        expand={false}
        collapseOnSelect
        variant="dark"
        className="navbar-theme-default px-4 d-md-none shadow"
      >
        <div className="text-center mb-3 mt-3 d-flex justify-content-center">
          <Link to="/dashboard">
            <Image
              src={Logo}
              alt="Logo"
              className="img-fluid "
              style={{ height: "30.72px", width: "120px", cursor: "pointer" }}
            />
          </Link>
        </div>
        <Navbar.Toggle
          as={Button}
          aria-controls="main-navbar"
          onClick={onCollapse}
        >
          <span className="navbar-toggler-icon" />
        </Navbar.Toggle>
      </Navbar>

      <CSSTransition timeout={300} in={show} classNames="sidebar-transition">
        <SimpleBar
          className={`collapse ${showClass} sidebar d-md-block bg-default text-black`}
        >
          <div className="sidebar-inner px-4 pt-3">
            <div className="text-center mb-3 mt-3 py-2 rounded d-flex justify-content-start shadow-sm">
              <Image
                src={Logo}
                alt="Logo"
                className="img-fluid"
                style={{ height: "30.72px", width: "120px", marginLeft: 15 }}
              />
            </div>
            <div className="user-card d-flex d-md-none align-items-center justify-content-end justify-content-md-center pb-4">
              {/* <div className="d-flex align-items-center">
                <div className="user-avatar lg-avatar me-4">
                  <Image
                    src={ProfilePicture}
                    className="card-img-top rounded-circle border-white"
                  />
                </div>
                <div className="d-block">
                  <h6>Hi, User</h6>
                  <Button
                    variant="secondary"
                    size="xs"
                    className="text-dark"
                    onClick={() => {
                      Cookies.remove("userRole");
                      navigate("/login"); // Use navigate to redirect after logout
                    }}
                  >
                    <FontAwesomeIcon icon={faSignOutAlt} className="me-2" />{" "}
                    Sign Out
                  </Button>
                </div>
              </div> */}
              <Nav.Link
                className="collapse-close d-md-none"
                onClick={onCollapse}
              >
                <FontAwesomeIcon icon={faTimes} />
              </Nav.Link>
            </div>
            {/* <hr className="border border-black mt-3 ms-1" /> */}
            <Nav className="flex-column pt-3 pt-md-0">
              {role === "super admin" ? (
                <>
                  <NavItem
                    title="Dashboard"
                    link="/super-admin/dashboard"
                    icon={faHome}
                  />
                  <NavItem
                    title="Agencies"
                    link="/super-admin/agencies"
                    icon={faBuilding}
                  />
                </>
              ) : role === "admin" ? (
                <>
                  <NavItem
                    title="Dashboard"
                    link="/admin/dashboard"
                    icon={faHome}
                  />
                  <NavItem
                    title="Add Users"
                    link="/admin/system-User"
                    icon={faUsers}
                  />
                  <NavItem
                    title="Category List"
                    link="/admin/Product"
                    // link="/admin/products-list"
                    icon={faBox}
                  />
                  <NavItem
                    title="Tags List"
                    link="/admin/tags-list"
                    icon={faTag}
                  />
                </>
              ) : null}
            </Nav>
          </div>
        </SimpleBar>
      </CSSTransition>
    </>
  );
};
